import { useSyncExternalStore } from 'react';
import { getOnlineStatus, subscribeOnlineStatus } from '@/lib/connectivity';

export function useOnlineStatus(): boolean {
  return useSyncExternalStore(subscribeOnlineStatus, getOnlineStatus, () => true);
}
